import { useEffect } from "react";
import { TrackingService } from "../shared/tracking/tracking.service";
import { useEventBus } from "@dfds-platform/business-components";

interface Args {
    trackingService: TrackingService
}

const OktaTracking = (args: Args) => {
    const { subscribe } = useEventBus()
    useEffect(() => {
        args.trackingService.trackOkta(subscribe)
    }, [])
    return null
}

export default OktaTracking